import { Entity } from "@backstage/catalog-model";

export const SENTRY_QUERY_ANNOTATION = "sentry.io/query";

export const useProjectQuery = (entity: Entity) => {
  return entity?.metadata.annotations?.[SENTRY_QUERY_ANNOTATION] ?? "";
};
